// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".map-svg{max-width:100%;overflow:hidden}.map-svg svg{left:-40px;max-width:100%;position:relative}.map-svg .available{fill:#f5c518}.map-svg .future-growth{fill:#f97316}.map-svg .almost-sold-out{fill:#7f1d1d}.map-svg .sold-out{fill:#1f2937}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
